<template>
  <div v-if="list.length" class="picker-list-container">
    <div class="picker-list-title">{{ title }}</div>
    <div class="picker-list">
      <div class="picker-item" v-for="(item, index) in list" :key="index" @click="clickPickerItem(item)">
        <i class="iconfont iconadd-circle"></i>
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EditorLabelPickerList",
  props: ["title", "list"],
  methods: {
    clickPickerItem(item) {
      this.$emit("clickPickerItem", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.picker-list-container {
  display: flex;
  flex-direction: column;
  .picker-list-title {
    font-size: 14px;
    color: $form-label-color;
    margin-bottom: 12px;
  }
  .picker-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    .picker-item {
      display: flex;
      align-items: center;
      border-radius: 4px;
      padding: 0 12px;
      height: 30px;
      color: $text-color;
      background-color: $btn-bg-color;
      cursor: pointer;
      .iconfont {
        margin-right: 4px;
      }
    }
  }
}
</style>
